export default __webpack_public_path__ + "static/media/ai-machine-tranning.539cf779.png";